import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';
import { formatMoney } from '@/utils/formatting';

@Component
export class FreeDeliveryMessage extends ThemeComponent {
    @Prop display!: boolean;
    @Prop threshold!: number;
    @Prop doesNotQualifyMessage!: string;
    @Prop doesNotQualifySubMessage!: string;
    @Prop qualifiesMessage!: string;
    @Prop qualifiesSubMessage!: string;

    @Ref doesNotQualifyMessageContainer!: HTMLElement;
    @Ref qualifiesMessageContainer!: HTMLElement;
    @Ref remainingSpend!: HTMLElement;

    init() {
        // Do not continue if not set to display
        // if (!this.display) {
        //     return;
        // }

        // // Multiply threshold value by 100 to ensure it is the same format as Shopify expects
        // this.threshold = this.threshold * 100;

        // // Subscribe to cart change events

        // document.addEventListener('cartChanged', () => {
        //     this.checkThreshold();
        // });

        // this.checkThreshold();
    }

    checkThreshold() {

        // Check if cart toal price is greater than threshold
        if (cart.totalPrice >= this.threshold) {

            // Show qualifies message
            this.qualifiesMessageContainer.classList.remove('free-delivery-message__qualifies-message--hidden');
            // eslint-disable-next-line max-len
            this.doesNotQualifyMessageContainer.classList.add('free-delivery-message__does-not-qualify-message--hidden');
        } else {

            // Determine how much more spend is required to qualify
            const cartTotal = cart.totalPrice;
            const remainingSpend = this.threshold - cartTotal;

            // Update message HTML
            this.remainingSpend.innerHTML = formatMoney(remainingSpend);

            // Show does not qualify message
            // eslint-disable-next-line max-len
            this.doesNotQualifyMessageContainer.classList.remove('free-delivery-message__does-not-qualify-message--hidden');
            this.qualifiesMessageContainer.classList.add('free-delivery-message__qualifies-message--hidden');
        }
    }
}
